import React from "react"
import Form from "react-bootstrap/lib/Form"

export default ({ input, label }) => <Form.Check {...input} label={label} />
